export default {
  start_error: {
    callBtn: true,
    callBtnText: 'לבירור הנושא אפשר ליצור איתנו קשר',
    titleBold: 'רק שניה, <br/> אנחנו לא מזהים שיש לכם מנוי סלולר…',
  },
  modem: {
    callBtn: true,
    callBtnText: 'אם תרצו לברר את הנושא או לעדכן לחבילה אחרת, <br/> אפשר ליצור איתנו קשר',
    description: 'זה אומר שאין אפשרות לעדכן בו את החבילה.',
    titleBold: 'אנחנו רואים שהמנוי מיועד לגלישה בלבד',
  },
  bundle: {
    titleBold: 'רגע, המנוי הוא חלק מחבילה של מוצרים',
    description: 'כדי לעדכן את כל החבילה, השאירו מספר טלפון ונחזור אליכם תוך יום עסקים',
  },
  sub_status: {
    titleBold: 'רגע, אנחנו רואים שהמנוי מושהה',
    description: 'כדי לבטל את ההשהיה ולהשלים את עדכון חבילת הסלולר,  <br/> השאירו מספר טלפון ונחזור אליכם תוך יום עסקים',
  },
  np_status: {
    callBtn: true,
    callBtnText: 'אם תרצו לברר את הנושא, אפשר ליצור איתנו קשר',
    description: 'אנחנו רואים שהמנוי נמצא בתהליך ניוד לכן אין אפשרות לעדכן את חבילת הסלולר כרגע.',
    titleBold: 'רק שנייה',
  },
  futurePPInd: {
    callBtn: true,
    callBtnText: 'אם תרצו לבטל את הבקשה ולבחור חבילה אחרת, <br/> אפשר ליצור איתנו קשר',
    titleBold: 'יש כבר בקשה קודמת לעדכון חבילת הסלולר הזו',
  },
  fix_price_with_futurePP: {
    titleBold: 'יש כבר בקשה פתוחה לשינוי בחבילה הזו',
    description: `מנוי ${'phone_number'} הוא חלק מחבילת סלולר עם בקשה פתוחה מאחד המנויים. לכן, אין כרגע אפשרות לעשות שינויים במנוי שבחרתם. השאירו מספר טלפון ונחזור אליכם תוך יום עסקים כדי לטפל בבקשה`,
  },
  error_on_change: {
    titleBold: 'רק רגע, עדכון החבילה לא הצליח...',
    description: 'במוקד השירות שלנו ישמחו לעזור. <br/> השאירו טלפון ונחזור אליכם תוך יום עסקים אחד',
  },
  server_error: {
    titleBold: 'רק רגע, משהו השתבש...',
    description: 'במוקד השירות שלנו ישמחו לעזור. <br/> השאירו מספר טלפון ונחזור אליכם תוך יום עסקים אחד',
  },
  error_failed_part_of: {
    withImage: false,
    callBtn: false,
    callBtnText: 'כמובן, לשירותך תמיד',
    titleBold: 'רגע, משהו קרה ורק חלק מהמנויים עודכנו',
    description: `מנויים ${'phone_numbers'}, עודכנו בהצלחה. <br/> <span className="error-long-text">בדקות הקרובות ניצור איתכם קשר כדי להשלים את עדכון שאר המנויים.</span>`,
  },
  the_same_plan: {
    callBtn: true,
    callBtnText: 'אם בכל זאת אנחנו יכולים לעזור, אפשר ליצור איתנו קשר',
    titleBold: 'רגע… זו בעצם אותה חבילה',
    description: 'אנחנו לא יודעים אם זה גורל, אבל חבילת הסלולר שבחרתם זהה לחבילה הנוכחית.<br/> כנראה שאתם מרוצים ממה שיש לכם :)',
  },
  account_type: {titleBold: 'לקוח יקר, <br/> לצורך מעבר תכנית אנא פנה ל *2759 '},
  callback_exist: {
    callBtn: true,
    callBtnText: 'אם בכל זאת רוצה לדבר איתנו',
    description: 'הנציג יחזור אליך ממש בקרוב',
    titleBold: 'נראה שכבר נרשמת <br/> לשיחה עם נציג',
  },

  limitedOnOTP: {
    titleBold: 'אינך יכול להעדכן את התוכנית במנוי זה',
    description: `מנוי ${'phone_number'} נמצא בתוכנית משותפת עם עוד מנויים. שינוי חבילה למנוי זה כרוך בשינוי עבור כל המנויים בחבילה ואפשרי בזיהוי נוסף`,
  },
};
